// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ErrorComponent.css */
.error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #F8F9FA;
    color: #223263;
    text-align: left;
    padding: 0 30%;
    box-sizing: border-box;
   
  }
  
  .error-text {
    flex: 1 1;
    max-width: 50%;
    margin-right: 40px;
    padding-bottom: 10%;
  }
  
  .error-text h1 {
    font-size: 4.5vw;
    margin: 0;
    color: #223263;
  }
  
  .error-text p {
    font-size: 2.2vw;
    color: #333;
  }
  
  .error-image-container {
    flex: 1 1;
    max-width: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-top: 15%;
  }
  
  .error-image-container::before {
    content: '';
    position: absolute;
    width: 40vw;
    height: 20vw;
    background-color: #444;
    border-radius: 50% 40% 50% 40%;
    transform: rotate(-30deg);
  }
  
  .error-image {
    width: 25vw;
    height: 25vw;
    position: relative;
    z-index: 1;
    
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Error.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,sBAAsB;;EAExB;;EAEA;IACE,SAAO;IACP,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;;EAEZ","sourcesContent":["/* ErrorComponent.css */\n.error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background-color: #F8F9FA;\n    color: #223263;\n    text-align: left;\n    padding: 0 30%;\n    box-sizing: border-box;\n   \n  }\n  \n  .error-text {\n    flex: 1;\n    max-width: 50%;\n    margin-right: 40px;\n    padding-bottom: 10%;\n  }\n  \n  .error-text h1 {\n    font-size: 4.5vw;\n    margin: 0;\n    color: #223263;\n  }\n  \n  .error-text p {\n    font-size: 2.2vw;\n    color: #333;\n  }\n  \n  .error-image-container {\n    flex: 1;\n    max-width: 75%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    padding-top: 15%;\n  }\n  \n  .error-image-container::before {\n    content: '';\n    position: absolute;\n    width: 40vw;\n    height: 20vw;\n    background-color: #444;\n    border-radius: 50% 40% 50% 40%;\n    transform: rotate(-30deg);\n  }\n  \n  .error-image {\n    width: 25vw;\n    height: 25vw;\n    position: relative;\n    z-index: 1;\n    \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
